import { css } from 'styled-components'
import { light } from '~/constants/theme'

const focusedInput = css<{ hasExceededMaxCount?: boolean }>`
  box-shadow: 0px 0px 1.5px 3.5px
    ${({ hasExceededMaxCount }) =>
      hasExceededMaxCount ? light.redFocus : `${light.focus}`};
  background-color: #fff;
  border: 1.25px solid
    ${({ hasExceededMaxCount }) =>
      hasExceededMaxCount ? light.red200 : light.dark800};
  outline-offset: 0;
  outline: none;
`

const easeInOutTransition = css`
  transition: all 0.15s ease-in-out;
`

const backgroundBoxShadow = css`
  box-shadow: 0px 8px 24px 4px rgba(0, 43, 64, 0.035);
`

const blurybackground = css`
  backdrop-filter: blur(8px);
  background-color: rgba(250, 250, 252, 0.85);
`

const blueToPurpleGradient = css`
linear-gradient(90deg, hsla(292, 91%, 32%, 1) 0%, hsla(230, 91%, 46%, 1) 59%, hsla(178, 93%, 37%, 1) 99%);
`

export {
  focusedInput,
  easeInOutTransition,
  backgroundBoxShadow,
  blurybackground,
  blueToPurpleGradient,
}
